import { canUseWebForms } from "../predicates";
import type { TourStepConfig } from "../../types/tour.types";

export const webFormsSteps: TourStepConfig[] = [
  {
    id: "webforms-create",
    target: "webforms.create",
    title: "Create a web form",
    content:
      "Pick one of your templates and it becomes a form with its own link. Anyone who opens that link fills in their own details and signs — you never address a request to them.",
    placement: "left",
    when: canUseWebForms,
  },
  {
    id: "webforms-list",
    target: "webforms.list",
    title: "Your web forms",
    content:
      "Each one shows the template it was built from and carries its own shareable signing link. Open a form to change its design, or use the row menu to rename or remove it.",
    placement: "bottom",
    when: canUseWebForms,
  },
];

export default webFormsSteps;
